export const NotificationType = Object.freeze({
	changed: 'changed',
	grid: 'grid',
	text: 'text',
	users: 'users',
	title: 'title',
});

export const DefaultNotificationIconTitleClass = Object.freeze({
	calendar: '--o-calendar-with-slots',
	task: '--o-task',
});

export const CrmNotificationIconTitleClass = Object.freeze({
	default: '--o-crm',
	deal: '--o-handshake',
	lead: '--o-lead',
	contact: '--o-contact',
	quote: '--o-file',
	company: '--o-company',
	order: '--o-box',
	process: '--o-smart-process',
	call: '--o-phone-up',
	task: '--o-complete-task-list',
	meeting: '--o-calendar-with-slots',
	mail: '--o-mail',
	invoice: '--o-invoice',
});

export const SonetNotificationIconTitleClass = Object.freeze({
	newsfeed: '--o-newsfeed',
	wiki: '--wiki',
	vote: '--o-complete-task-list',
	group: '--o-three-persons',
});

export const BizprocNotificationIconTitleClass = Object.freeze({
	bizproc: '--o-business-process',
	customSection: '--o-activity',
});
